const replaceTags = /(<br ?\/?>|<hr ?\/?>)/gi;

// \s\S matches all character including lines break (which `.` does not)
const escapeHtml = /<[\s\S]*?>/gi;

/**
 * Count the text characters in an html string, ignoring the tags and their attributes
 * (except `br` and hr `that` count as 1 character)
 *
 * @param html The HTML string
 * @returns
 */
export const escapeHtmlAndCountCharacters = (html: string): number => {
  const replaced = html.replaceAll(replaceTags, '_');
  const escaped = replaced.replaceAll(escapeHtml, '');

  return escaped.length;
};
